import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  eventList: [],
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setEventList: (state, action) => {
      state.eventList = action.payload.list;
    }
  },
});

export const {
  setEventList,
} = calendarSlice.actions;

export default calendarSlice.reducer;